import {
  Response,
  baseHttpFormData,
  httpGet,
  httpPatch,
  httpPostMultiPart,
} from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";

import { BodyProps } from "./profile.type";

const { REACT_APP_BASE_URL } = process.env;

const initialState = {};

const updateUser = createAsyncThunk(
  "profile/update user",
  async (body: BodyProps) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPatch(`${REACT_APP_BASE_URL}/api/v1/users/profile`, body, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const getUserStats = createAsyncThunk("profile/get user stats", async () => {
  let results: Response | null;
  try {
    results = await trackPromise(
      httpGet(`${REACT_APP_BASE_URL}/api/v1/users/profile-stats`, true)
    );
    return Promise.resolve(results?.data);
  } catch (error) {
    return Promise.reject(error);
  }
});

const getUserReviewStats = createAsyncThunk(
  "profile/get user review stats",
  async () => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpGet(`${REACT_APP_BASE_URL}/api/v1/player-reviews/stats`, true)
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

// const uploadProfileImage = createAsyncThunk(
//   "profile/Uploads an image for the user profile",
//   async (formData: any) => {
//     let results: Response | null;
//     console.log("======>", formData);
//     try {
//       results = await trackPromise(
//         httpPostMultiPart(
//           `${REACT_APP_BASE_URL}/api/v1/users/profile/image`,
//           formData,
//           true
//         )
//       );
//       return Promise.resolve(results?.data);
//     } catch (error) {
//       return Promise.reject(error);
//     }
//   }
// );

const uploadProfileImage = createAsyncThunk(
  "profile/Uploads an image for the user profile",
  async (formData: any) => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPostMultiPart(
          `${REACT_APP_BASE_URL}/api/v1/users/profile/image`,
          formData
        )
      );

      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const profileReducer = profileSlice.reducer;

export const profileActions = {
  ...profileSlice.actions,
  updateUser,
  getUserStats,
  getUserReviewStats,
  uploadProfileImage,
};
